$(document).on('click', '.addToFavorite', function(e){
  e.preventDefault();

  var product_id = $(this).data('product-id');
  var csrf = $('meta[name="csrf-token"]').attr('content');



  var data_form = {
    product_id: product_id,
    _token: csrf
  }

  $.ajax({
    url: $(this).attr('href'),
    dataType: 'json',
    type: 'post',
    data: data_form,
    success: function(data){
      $('.product-info .addToFavorite').html(data.text);
      $('.user_whishlist_row .product-' + product_id).remove();
      $('.home-products .favorite-'+product_id+' .fa-heart').toggleClass('fas far color-dark-red');
      $('.products-col .favorite-'+product_id+' .fa-heart').toggleClass('fas far color-dark-red');
    }
  })

})
